import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_CLIENT_ID || '938bdfb9-e00b-4363-a498-97ddf5641c42',
      authority: process.env.REACT_APP_AUTHORITY || 'https://login.microsoftonline.com/8ee0f3e4-b788-4efa-bd84-e6bfe7fe9943',
      redirectUri: '/Dashboard',
      postLogoutRedirectUri: "/"
    },
    cache: {
      cacheLocation: 'localStorage',  // Can be 'localStorage' or 'sessionStorage'
      storeAuthStateInCookie: true,  // Set to true for IE11/Edge compatibility
    },
    system:{
      loggerOptions: {
        loggerCallback: (level:any, message:any, containsPii:any) => {
          if(containsPii){
            return;
          }
          switch(level){
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
            default:
              return;
          }
        }
      }
    }
};
export const loginRequest = {
    scopes: ['User.Read'],  // Define the scopes you need
};